import {
  recentPromptsAtom,
  selectedPromptIdAtom,
} from "@mirage/search/SearchResults/atoms";
import {
  deletePrompt,
  fetchRecentPrompts,
  setDefaultPromptId,
} from "@mirage/service-compute-relevance";
import { type RelevanceRubric } from "@mirage/service-compute-relevance/service/types";
import { useAtom } from "jotai";
import { useCallback, useEffect } from "react";

export const useRecentPrompts = (rubric: RelevanceRubric) => {
  const [recentPrompts, setRecentPrompts] = useAtom(recentPromptsAtom);
  const [selectedPromptId, setSelectedPromptId] = useAtom(selectedPromptIdAtom);

  const fetchAndUpdatePrompts = useCallback(async () => {
    const prompts = await fetchRecentPrompts(rubric);
    setRecentPrompts(prompts);
  }, [rubric, setRecentPrompts]);

  useEffect(() => {
    fetchAndUpdatePrompts();
  }, [fetchAndUpdatePrompts]);

  const refetchRecentPrompts = useCallback(() => {
    fetchAndUpdatePrompts();
  }, [fetchAndUpdatePrompts]);

  const deletePromptAndRefetch = useCallback(
    async (promptId: string): Promise<void> => {
      await deletePrompt(promptId, rubric);
      refetchRecentPrompts();
    },
    [rubric, refetchRecentPrompts],
  );

  const setDefaultPrompt = useCallback(
    async (promptId: string | null): Promise<void> => {
      await setDefaultPromptId(rubric, promptId);
      refetchRecentPrompts();
    },
    [rubric, refetchRecentPrompts],
  );

  return {
    recentPrompts,
    selectedPromptId,
    setSelectedPromptId,
    refetchRecentPrompts,
    deletePrompt: deletePromptAndRefetch,
    setDefaultPrompt,
  };
};
